import { AccountRequestDataWidget } from 'feature/account/request-data';
import { component, demoFile, variant } from "system/demo";

demoFile('feature/account/request-data', {
    designUrl: 'https://www.figma.com/design/iP7DEaY8SVqQcEGN6Feipj/Basic-Profile-%2B-Privacy-Settings?node-id=1966-5780&p=f&t=MYbBGUW6ZQjY60Ab-0',
})

component('AccountRequestDataWidget', AccountRequestDataWidget)
